// extracted by mini-css-extract-plugin
export var orderSummary = "_rd-0";
export var showMoreLessButton = "_rd-1";